// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-card {
  transition: transform 0.2s, box-shadow 0.2s;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.product-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.product-image-wrapper {
  height: 250px;
  overflow: hidden;
  background-color: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #dee2e6;
}

.product-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 10px;
}

.smart-image-fallback {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 20px;
}

.product-image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
}

.product-image-placeholder-list {
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.product-name {
  font-size: 1.1rem;
  line-height: 1.3;
  min-height: 2.6em;
}

.product-list-image {
  max-height: 100px;
  object-fit: contain;
}

.product-image-lg {
  width: 100%;
  height: 100%;
  max-height: 400px;
  object-fit: contain;
}`, "",{"version":3,"sources":["webpack://./src/components/Products.css"],"names":[],"mappings":"AAAA;EACE,2CAA2C;EAC3C,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB","sourcesContent":[".product-card {\n  transition: transform 0.2s, box-shadow 0.2s;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.product-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 5px 15px rgba(0,0,0,0.1);\n}\n\n.product-image-wrapper {\n  height: 250px;\n  overflow: hidden;\n  background-color: #f8f9fa;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.product-image {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  padding: 10px;\n}\n\n.smart-image-fallback {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  padding: 20px;\n}\n\n.product-image-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: #f8f9fa;\n}\n\n.product-image-placeholder-list {\n  width: 100px;\n  height: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n}\n\n.product-name {\n  font-size: 1.1rem;\n  line-height: 1.3;\n  min-height: 2.6em;\n}\n\n.product-list-image {\n  max-height: 100px;\n  object-fit: contain;\n}\n\n.product-image-lg {\n  width: 100%;\n  height: 100%;\n  max-height: 400px;\n  object-fit: contain;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
